import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import type { AxiosInstance } from "axios";

let establishmentsApiPromise: Promise<AxiosInstance> | null = null;

const getEstablishmentsApi = async (): Promise<AxiosInstance | null> => {
  if (establishmentsApiPromise !== null) return establishmentsApiPromise;
  establishmentsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return establishmentsApiPromise;
};

export interface LotePolygonPoint {
  longitud: number;
  latitud: number;
}

export interface EstablishmentLote {
  nombreLote: string;
  id: string;
  hectareas: number;
  perimetro: string;
  coordenadasPoligono: {
    puntos: LotePolygonPoint[];
  };
}

export interface EstablishmentItem {
  nombre: string;
  tipoCampo: string;
  cantidadLotes: number;
  sumaHALotes: number;
  id: string;
  latitud: number;
  longitud: number;
  lotes: EstablishmentLote[];
}

export interface EstablishmentDetailResponse {
  nombreProductor: string;
  establecimientos: EstablishmentItem[];
}

export const getEstablishmentDetail = async (
  cuentaOrigen: number,
): Promise<EstablishmentDetailResponse | null> => {
  const api = await getEstablishmentsApi();
  if (!api) return null;
  const response = await api.get(
    `/Establecimientos?${objectToQueryStringWithArray({ CuentaOrigen: cuentaOrigen })}`,
  );
  return response.data;
};

export interface PatchEstablishmentTypeBody {
  idEstablecimiento: string;
  situacion: number;
}

export const patchEstablishmentType = async (
  body: PatchEstablishmentTypeBody,
): Promise<void> => {
  const api = await getEstablishmentsApi();
  if (!api) return;
  await api.patch(`/Establecimientos/${body.idEstablecimiento}`, body);
};
